<template>
    <form
        method="post"
        class="grid grid-cols-12 gap-6 px-2"
        :class="{ 'disabled-form': loading }"
        @submit.prevent="saveForm"
    >
        <div v-if="loading" class="absolute z-100 left-0 top-0 w-full h-full flex items-center justify-center">
            <Preloader />
        </div>

        <div class="relative col-span-12">
            <label for="form-title" class="form-label">
                Заголовок
                <sup v-if="v$.form.title.required" class="text-theme-6">*</sup>
            </label>
            <label v-if="v$.form.title.$errors.length" for="form-title" class="form-input-text-error">
                {{ getOverrideMessage(v$.form.title.$errors[0].$message) }}
            </label>
            <input
                id="form-title"
                v-model="form.title"
                type="text"
                class="form-control"
                :class="{ 'form-input-error': v$.form.title.$errors.length }"
                autocomplete="off"
            />
        </div>

        <div class="col-span-12">
            <label class="form-label">Описание</label>
            <CustomWyswig v-model="form.description" />
        </div>

        <div class="col-span-12">
            <label class="form-label">Изображения</label>
            <UploadMultiImageNew v-model="form.images" />
        </div>

        <div class="col-span-12 flex justify-end">
            <button type="button" class="btn btn-secondary mr-2 w-24" @click.prevent="$emit('dataSaved')">
                Отмена
            </button>
            <button type="submit" class="btn btn-primary">Сохранить</button>
        </div>
    </form>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { errorResponse } from '@/mixins/form/form-mixin';
import CustomWyswig from '@/components/base/custom-wyswig/Main';
import Preloader from '@/components/preloader/Main';
import UploadMultiImageNew from '@/components/upload-image/UploadMultiImageNew';
import { helper as $h } from '@/utils/helper';
import { formPreparation } from '@/utils/object-to-form-data';

export default {
    name: 'CrudCabinType',
    components: { UploadMultiImageNew, Preloader, CustomWyswig },
    mixins: [errorResponse],
    emits: ['dataSaved'],
    setup() {
        return { v$: useVuelidate() };
    },
    data() {
        return {
            loading: false,
            form: {
                title: null,
                description: null,
                images: [],
            },
        };
    },
    validations() {
        return {
            form: {
                title: { required },
            },
        };
    },
    methods: {
        async saveForm() {
            const isFormCorrect = await this.v$.$validate();
            if (!isFormCorrect) {
                this.$notify({ text: 'Заполните все поля правильно', type: 'error' });
                return;
            }

            const form = formPreparation(this.form, { imagesAsObject: true });

            this.axios
                .post(`/ships/${this.$route.params.id}/cabin-types`, form)
                .then((response) => {
                    this.$emit('dataSaved', true);
                    this.$notify(response.data.message);
                })
                .catch((ex) => {
                    this.errorResponse(ex);
                });
        },
        getOverrideMessage(message) {
            return $h.getOverrideMessage(message);
        },
    },
};
</script>

<style scoped></style>
